import React from 'react';
import Button from '../button/Button';
import dispatchEvent from '../../fns/common/dispatchEvent';

const SportsContest = () => {
  const cardData = [
    {
      title: 'MetaFans NFL 2025-2026 Schedule',
      items: [
        'Weekly Square Pools for Prime-Time Games (TH, SUN, MON)',
        'NFL Playoffs & Superbowl square pools',
        <span>
          See MetaFans Levels for How to Qualify{' '}
          <a
            href="/new-member-benefits"
            className="underline hover:text-blue-400 transition-colors"
            style={{ color: '#3872FF' }}
          >
            here
          </a>
        </span>,
        <span>
          Holders must join Discord{' '}
          <a
            href="https://discord.gg/metafans"
            target="_blank"
            className="underline hover:text-blue-400 transition-colors"
            style={{ color: '#3872FF' }}
            rel="noopener noreferrer"
          >
            here
          </a>{' '}
          and verify Wallet holdings
        </span>,
        <span>
          Submit your weekly NFL picks{' '}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScykRYFp0iqv4Hx0bxlKeOvOr0VuWiR-_utOp4LsFh_NRrbag/viewform"
            target="_blank"
            className="underline hover:text-blue-400 transition-colors"
            style={{ color: '#3872FF' }}
            rel="noopener noreferrer"
          >
            here
          </a>
        </span>,
      ],
      flipItems: [
        
        'Anyone who enters a league they are not eligible for will forfeit prizes for all leagues that week.',
        'All prizes for leagues TBD by management',
      ],
    },
    {
      title: 'MetaFans CFB 2025-2026 Schedule',
      items: [
        'Weekly Square Pools for Saturday prime time college football',
        'MetaFans College National Championship Playoff Challenge',
        <span>
          See MetaFans Levels for How to Qualify{' '}
          <a
            href="/new-member-benefits"
            className="underline hover:text-blue-400 transition-colors"
            style={{ color: '#3872FF' }}
          >
            here
          </a>
        </span>,
        <span>
          Holders must join Discord{' '}
          <a
            href="https://discord.gg/metafans"
            target="_blank"
            className="underline hover:text-blue-400 transition-colors"
            style={{ color: '#3872FF' }}
            rel="noopener noreferrer"
          >
            here
          </a>{' '}
          and verify Wallet holdings
        </span>,
      ],
      flipItems: [
        
        'Anyone who enters a league they are not eligible for will forfeit prizes for all leagues that week.',
        'All prizes for leagues TBD by management',
      ],
    },
    {
      title: 'MetaFans PGA GOLF',
      items: [
        'MetaFans PGA Major Golf Tournament Challenge for RMB',
        '$2,500 prize pool per Major Golf Tournament',
        <span>
          See MetaFans Levels for Qualification Status{' '}
          <a
            href="/new-member-benefits"
            className="underline hover:text-blue-400 transition-colors"
            style={{ color: '#3872FF' }}
          >
            here
          </a>
        </span>,
        <span>
          Holders must join Discord{' '}
          <a
            href="https://discord.gg/metafans"
            target="_blank"
            className="underline hover:text-blue-400 transition-colors"
            style={{ color: '#3872FF' }}
            rel="noopener noreferrer"
          >
            here
          </a>{' '}
          and verify Wallet holdings
        </span>,
      ],
      flipItems: [
        
        'Anyone who enters a league they are not eligible for will forfeit prizes for all leagues that week.',
        'All prizes for leagues TBD by management',
      ],
    },
    {
      title: 'Coming Soon in 2026',
      items: [
        'NCAA Basketball March Madness Bracket Challenge prize pool $10,000',
        'MetaFans NBA Playoffs for RMB $5,000 prize pool',
        'MetaFans NHL Playoffs for RMB $5,000 NHL Prize pool',
        
      ],
      flipItems: [
        
        'Anyone who enters a league they are not eligible for will forfeit prizes for all leagues that week.',
        'All prizes for leagues TBD by management',
      ],
    },
    
  ];

  return (
    <div className="bg-gray-900 text-white w-full min-h-screen p-4 sm:p-6 md:p-8 flex flex-col items-center">
      <div className="w-full max-w-7xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-center mb-6" style={{ color: '#fff' }}>
          🏈 Mint 4 MetaFans NFTs & Unlock These Unrivaled Real Money Benefits
        </h1>
        <ul className="space-y-4 text-base sm:text-lg">
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>💵</span>
            <span>
              <strong>Weekly Sports Picks:</strong> Win up to $500/week for 26 weeks
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>🎯</span>
            <span>
              <strong>Free Entry into Weekly Squares Pools:</strong> During NFL primetime games, starting 9/4 with the{' '}
              <a
                href="https://www.nfl.com/schedules/2025/REG1/"
                className="hover:underline"
                style={{ color: '#3872FF' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                NFL Kickoff game Cowboys Vs. Eagles
              </a>{' '}
              for a special prize pool of $125 + Free MF NFT per quarter!
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>♠️</span>
            <span>
              <strong>Online Poker Tournaments:</strong> Entry paid by MetaFans at{' '}
              <a
                href="https://record.secure.acraffiliates.com/_xpjyw5c5vemt3MpizEWS4mNd7ZgqdRLk/1/"
                className="hover:underline"
                style={{ color: '#3872FF' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                ACR Poker
              </a>
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>🏈</span>
            <span>
              <strong>Exclusive Fantasy Football Leagues:</strong> For MetaFans Holders. Join one of the three 20 Team Season Long
              Leagues with top scoring teams for each week winning $100 in ETH & A MetaFans NFT!
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>🧠</span>
            <span>
              <strong>NFL's Biggest Loser Survivor Challenge:</strong> Mint 1 MetaFans NFT from the website and gain entry to
              this challenge with a Prize Pool Payout of $10,000 in ETH to the top 5 Losers (aka Winners).
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>🏀⚾🏒</span>
            <span>
              <strong>Major Sports Bracket Challenges Year-Round:</strong> NFL, NBA, NHL, NCAA, PGA & Major League Baseball
              Playoff Bracket Starting in October.
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>🎁</span>
            <span>
              <strong>Exclusive Year-Round Giveaways & Promos</strong>
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2" style={{ color: '#3872FF' }}>🏆</span>
            <span>
              <strong>Coming Soon:</strong> $1,000 Weekly Private Contest Prize Pools via GameBlazers
            </span>
          </li>
        </ul>
        <div className="text-center mt-8">
          <Button
            variant="Primary"
            className="w-full sm:w-auto px-6 py-3 text-lg font-bold"
            style={{ backgroundColor: '#3872FF', color: '#FFFFFF' }}
            onClick={() => dispatchEvent('opensaleModalRequested')}
          >
            Mint a MetaFans NFT
          </Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mt-8">
          {cardData.map((card, index) => (
            <div key={index} className="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-md">
              <h2 className="text-xl sm:text-2xl font-semibold mb-4" style={{ color: '#3872FF' }}>
                {card.title}
              </h2>
              <ul className="space-y-2 text-sm sm:text-base">
                {card.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="mr-2" style={{ color: '#3872FF' }}>•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-4">
                <h3 className="text-base sm:text-lg font-semibold" style={{ color: '#3872FF' }}>
                  Additional Info:
                </h3>
                <ul className="space-y-2 text-xs sm:text-sm text-gray-300">
                  {card.flipItems.map((flipItem, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="mr-2" style={{ color: '#3872FF' }}>•</span>
                      <span>{flipItem}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SportsContest;